import axios from "axios";



const axiosCli = axios.create({
    baseURL: 'https://solutions.fusepong.com/api',
    //baseURL: 'https://newsolutions.fusepong.com/api/',
    //baseURL: 'http://192.168.0.33:4000/api/',
    //baseURL: 'https://staging.fusepong.com/api/',
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Acept-Language': 'es',
        'Access-Control-Allow_Methods': 'GET, POST, PATH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authentication, Accept-Language',
        'Access-Control-Max-Age': '1728000',
    }
});

export default axiosCli;
